import React from 'react';
import { useSelector } from 'react-redux';
import { leadColorScaleSelector } from '../../ecg/selectors/signal.selectors';
import { Leads } from '../../ecg/types/signal';
import { useStrip } from '../hooks/useStrip';
import { Lead } from './Lead';

interface Props {
  colorLeads: boolean;
  frequency: number;
  leadsData: Leads;
}

export const LeadsContainer: React.FC<Props> = ({
  leadsData,
  frequency,
  colorLeads,
}) => {
  const { leads, height } = useStrip();
  const colorScale = useSelector(leadColorScaleSelector);

  const getColor = (leadName: string) =>
    colorLeads ? colorScale(leadName) : undefined;

  return (
    <g className='leads' transform={`translate(0 ${height / 2})`}>
      {leads.map((leadName) => (
        <Lead
          key={leadName}
          color={getColor(leadName)}
          lead={leadsData[leadName]}
          frequency={frequency}
        />
      ))}
    </g>
  );
};
